"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScrollGradient = void 0;
var tslib_1 = require("tslib");
// (C) 2020-2022 GoodData Corporation
tslib_1.__exportStar(require("./typings"), exports);
var ScrollGradient_1 = require("./ScrollGradient");
Object.defineProperty(exports, "ScrollGradient", { enumerable: true, get: function () { return ScrollGradient_1.ScrollGradient; } });
//# sourceMappingURL=index.js.map